import { Component, Input } from '@angular/core';
import { PlatformService, InstituteSearchResult, NotificationsService, LoggingService, TokenService, LocalStorageService, SiteLayout } from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { ToastController, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the HeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'team-header',
    templateUrl: 'team-header.html'
})
export class TeamHeaderComponent extends BaseComponent {
    
    teamLogoPath: string;
    teamHeaderImagePath: string;
    teamLogoVisible: boolean;
    // Add @Input for component/template binding
    isWebApp: boolean;
    logoPath: string;
    @Input() public teamInfo: Promise<InstituteSearchResult> | null;
    globalSettings: { dynamicHeaderSize: boolean } = { dynamicHeaderSize: false };
    EmbedFlag: boolean;

    constructor(
        protected platformService: PlatformService,
        protected notificationsService: NotificationsService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "TeamHeaderComponent"
        );
    }

    ngOnInit() {
        super.ngOnInit();

        this.globalSettings = (window as any).__GlobalSettings;

        this.isWebApp = this.platformService.isWebApp;

        this.EmbedFlag = (window as any).__GlobalSettings.EmbedFlag || false;
        this.loggingService.log("EmbededFlag --- " + this.EmbedFlag);
        this.localStorageService.add("EmbedFlag", String(this.EmbedFlag));

        this.platformService.webAppFlag$
            .takeUntil(this.componentDestroyed$)
            .subscribe(
                (value) => {
                    this.isWebApp = value;
                })

        if (this.notificationsService.sitelayout) {
            this.configureImages(this.notificationsService.sitelayout);
        }

        this.notificationsService.sitelayout$
            .takeUntil(this.componentDestroyed$)
            .subscribe((value) => {
                this.configureImages(value);

                this.teamLogoVisible = value.ShowHeaderLogo;
            })
    }

    configureImages(value: SiteLayout) {
        this.teamHeaderImagePath = "";
        this.teamLogoPath = "";
        if (this.EmbedFlag == false) {
            this.teamHeaderImagePath = this.basePath + value.HeaderImage;
            this.teamLogoPath = this.basePath + value.TeamLogo;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/team-header/team-header.ts